const RETENTION_SENT = 'RETENTION_SENT';

export const get = (key: string): string | null => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.getItem(key);
  }
  return null;
};

export const set = (key: string, value: string): void => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.setItem(key, value);
  }
};

export const clear = (key: string): void => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.removeItem(key);
  }
};

export const RetentionSent = {
  get: (): string | boolean | null => get(RETENTION_SENT),
  set: (value: string): void => set(RETENTION_SENT, value),
};

export default {
  get,
  set,
  clear,
};
